import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { component, property } from '../../../concepts/objects';
import { memoUsing } from '../../../concepts/objects/MemoUsing';
import { Physical, PotentialInteraction } from '../../canvas/entities/Physical';
import { RectangularPhysical } from '../../canvas/entities/RectangularPhysical';
import { Snappable } from '../../canvas/entities/Snappable';
import { Pingable } from '../presentation/Pingable';
import { buzzerSpin as buzzerBuzz } from './BuzzerCommands';
import { BuzzerLayout } from './BuzzerLayout';
import { buzzerPropertyLayout } from './BuzzerPropertyLayout';

const invocation = defineCommand(
    'buzzerInvocation',
    null,
    (cc, [id, hint]: [string, string?]) => {
        cc.dispatch(buzzerBuzz, [id]);
    },
    [],
);

const mutation = defineCommand(
    'buzzerMutation',
    null,
    (r, [id]: [string]) => {
        // r.call(EditorSession).update(AdapterInfo, CreateAdapterInfo(id, 'field'));
    },
    [],
);

const buzzerDef = {
    name: 'Buzzer',
    implements: [Physical, Snappable, Pingable],
    propertyLayout: buzzerPropertyLayout,
    invocation,
    mutation,
};

const buzzerTransformHints = Object.freeze({
    scaleX: false,
    scaleY: false,
    rotate: false,
    translate: true,
    visible: true,
});

@component(buzzerDef)
export class Buzzer extends RectangularPhysical {

    @property({ type: 'string', default: '#c3352b' })
    public color: string;

    @property({ type: 'string' })
    public sound: string;

    public get boundary() {
        return true;
    }

    @memoUsing('width', 'height')
    public get layout() {
        return BuzzerLayout(this);
    }

    public get shouldSnap() {
        return true;
    }

    public queryTransformHints() {
        return buzzerTransformHints;
    }

    public testInteraction({ type, mpt }: PotentialInteraction): [boolean, string] {
        const { buzz } = this.layout;
        const rpt = this.toRelative(mpt);
        if (this.localBounds.contains(rpt)) {
            if (type === 'invoke' && rpt.distanceTo(buzz.center()) < buzz.width / 2) {
                return [true, 'buzz'];
            }
            if (type !== 'invoke') {
                return [true, 'default'];
            }
        }
        return [false, 'none'];
    }

    // protected setTransformationResult(x: number, y: number, r: number, w: number, h: number): void {
    //     w = Math.min(1600, Math.max(400, w));
    //     h = Math.min(1600, Math.max(400, h));
    //     super.setTransformationResult(x, y, r, w, h);
    // }
}

